/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6fa3fb0046b3e342809c7777e253d803>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Border".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/border
 * Usage guidance:
 * Reserved for toggling the visibility of a border on an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const BorderIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "BorderIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0M12 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 12 8m-3.25 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0-6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
BorderIcon.displayName = 'BorderIcon';
var _default = exports.default = BorderIcon;